import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from '@kimbocare/core';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {

  constructor(private sessionService: SessionService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentGroup = this.sessionService.getCurrentGroup();
    let tenantUuid = null;

    if (typeof localStorage !== 'undefined') {
      tenantUuid = localStorage.getItem('tenant_uuid');
    }

    if (currentGroup === undefined && tenantUuid) {
      request = request.clone({
        setHeaders: {
          'X-Tenant': tenantUuid,
          'source': 'tenant'
        }
      });
    } else {
      request = request.clone({
        setHeaders: {
          'source': 'tenant'
        }
      });
    }

    return next.handle(request);
  }
}
